import { render, staticRenderFns } from "./InputEmployees.vue?vue&type=template&id=3020b744"
import script from "./InputEmployees.vue?vue&type=script&lang=js"
export * from "./InputEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports